var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27767 21C6.96696 21 4.81298 20.3045 3 19.1046C4.53928 19.2077 7.25576 18.9608 8.94541 17.2931C6.40363 17.1724 5.25733 15.1552 5.10781 14.2931C5.32378 14.3793 6.35379 14.4828 6.93524 14.2414C4.01136 13.4828 3.56281 10.8276 3.66248 10.0172C4.21071 10.4138 5.14104 10.5517 5.50652 10.5172C2.78199 8.5 3.76216 5.46552 4.24394 4.81034C6.19916 7.61336 9.12943 9.18764 12.7546 9.27521C12.6862 8.965 12.6501 8.64205 12.6501 8.31034C12.6501 5.92981 14.5096 4 16.8034 4C18.0018 4 19.0817 4.52682 19.8398 5.36949C20.6406 5.1753 21.8459 4.7207 22.4352 4.32759C22.1382 5.43103 21.2135 6.35154 20.6542 6.69271C20.6589 6.70432 20.6497 6.68105 20.6542 6.69271C21.1455 6.61581 22.4748 6.35145 23 5.98276C22.7403 6.60266 21.76 7.63336 20.9555 8.2104C21.1052 15.0412 16.0546 21 9.27767 21Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.d5cfdda95f0f32d0e2be5c7fed0ddab8.svg";
export { ForwardRef as ReactComponent };